import React from "react";
import PortfolioBanner from "./PortfolioBanner/PortfolioBanner";
import Readytostart from "../Products/readytostart";
import { useEffect } from "react";
import SEO from "../../AASeo/Seo";

const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "IDLBAY Private Limited",
  alternateName: "IDLBAY",
  url: "https://idlbay.com",
  logo: "https://idlbay.com/idlbaylogo.png",
  sameAs: [
    "https://www.linkedin.com/company/idlbay/",
    "https://x.com/idlbayPvtLtd",
    "https://www.instagram.com/idlbay.official?igsh=dnIxMm50cmdxNDNy",
    "https://www.facebook.com/profile.php?id=61582746578911",
    "https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-9840841840",
    contactType: "Customer Support",
    areaServed: "IN",
    availableLanguage: ["English", "Tamil"],
  },
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street",
    addressLocality: "T-Nagar, Chennai",
    addressRegion: "Tamil Nadu",
    postalCode: "600017",
    addressCountry: "IN",
  },
};

const MainPortfolio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      style={{
        background:
          "linear-gradient(120deg, #2d3561 0%, #1a1a2e 50%, #232859 100%)",
        overflow: "hidden",
      }}
    >
      <SEO
        title="Our Portfolio | IDLBAY - Projects & Case Studies"
        description="Explore IDLBAY's portfolio of successful IT projects, software solutions, and digital case studies for clients across industries."
        keywords="IDLBAY portfolio, IT projects, case studies, software solutions, digital portfolio, client work"
        url="https://idlbay.com/portfolio"
        organization={organization}
      />
      <PortfolioBanner />
      <Readytostart />
    </div>
  );
};

export default MainPortfolio;
